module.exports = __webpack_public_path__ + "img/spongebobs_spatula.77c21ccc.jpg";